import React from "react";
import { Link } from "react-router-dom";
import { Box, Typography, Button, useMediaQuery } from "@mui/material";
import { styled } from "@mui/material/styles";
import Header from "../Components/Header";

const NotFoundContainer = styled(Box)({
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	justifyContent: "center",
	minHeight: "80vh",
});

const NotFoundTitle = styled(Typography)({
	fontSize: "6rem",
	fontWeight: "bold",
	marginBottom: "1rem",
});

const NotFoundText = styled(Typography)({
	fontSize: "1.5rem",
	marginBottom: "2rem",
	textAlign: "center",
	maxWidth: "80%",
});

const NotFound = () => {
	const isSmallScreen = useMediaQuery("(max-width:600px)");

	return (
		<>
			<Header />
			<NotFoundContainer>
				<NotFoundTitle>{isSmallScreen ? "404" : "Oops! 404"}</NotFoundTitle>
				<NotFoundText>
					{isSmallScreen
						? "The page you are looking for does not exist."
						: "The page you are looking for does not exist. Please check the URL and try again."}
				</NotFoundText>
				<Button
					component={Link}
					to="/"
					sx={{
						color: "white",
						border: "2px solid white",
						borderRadius: "50px",
						padding: "0.5rem 1rem",
						textTransform: "none",
					}}
				>
					Go back to home
				</Button>
			</NotFoundContainer>
		</>
	);
};

export default NotFound;
